import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { ApiService } from "../ApiService";
import LupaIcon from "../../svg/lupaIcon";
import CallApi from "../../data/CallApi";

const SendProducts = ({ isOpen, onClose, products, list_suc, auth, key_branch, refresh }) => {
	const API_url = process.env.REACT_APP_API_URL;

	const [filteredOptions, setFilteredOptions] = useState([]);
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const [listAll, setListAll] = useState(false);

	const [sucursales, setSucursales] = useState(list_suc);
	const [stateUpload, setStateUpload] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setFilteredOptions(products);
			setSearchValue("");
			setSelectedProducts([]);
		}
	}, [isOpen, products]);

	useEffect(() => {
		// if (listAll) {
		// 	const filtered = products.filter(
		// 		(product) => !selectedProducts.some((selected) => selected.code === product.code)
		// 	);
		// 	setFilteredOptions(filtered);
		// } else {
		// 	const filtered = products.filter(
		// 		(product) =>
		// 			product.name.toLowerCase().includes(searchValue.toLowerCase()) &&
		// 			!selectedProducts.some((selected) => selected.code === product.code)
		// 	);
		// 	setFilteredOptions(filtered);
		// }
		const filtered = products.filter((product) => {
			const search = searchValue.toLowerCase();

			return (
				(
					product.name.toLowerCase().includes(search) ||
					product.code.toString().toLowerCase().includes(search)
				) &&
				!selectedProducts.some(
					(selected) => selected.code === product.code
				)
			);
		});
		setFilteredOptions(filtered);
	}, [searchValue, products, selectedProducts, listAll]);

	const handleInputChange = (e) => {
		setSearchValue(e.target.value);
	};

	const handleSelectProduct = (product) => {
		if (product.stock > 0) {
			setSelectedProducts((prev) => [...prev, { ...product, quantity: 1 }]);
		} else {
			toast.error("El producto no tiene stock disponible.");
		}
	};

	const handleIncreaseQuantity = (index) => {
		setSelectedProducts((prev) => {
			const updated = [...prev];
			if (updated[index].quantity < updated[index].stock) {
				updated[index].quantity += 1;
			} else {
				toast.error("No puedes sobrepasar el stock disponible.");
			}
			return updated;
		});
	};

	const handleDecreaseQuantity = (index) => {
		setSelectedProducts((prev) => {
			const updated = [...prev];
			if (updated[index].quantity > 1) {
				updated[index].quantity -= 1;
			} else {
				toast.error("La cantidad no puede ser menor a 1.");
			}
			return updated;
		});
	};

	const handleRemoveProduct = (index) => {
		setSelectedProducts((prev) => {
			const updated = [...prev];
			updated.splice(index, 1);
			return updated;
		});
	};

	async function sendProduct() {
		const selected_suc = document.getElementById("transfer-product");
		if (!selected_suc) return;

		const array_data = {
			branch_transfer: selected_suc.value,
			tlength: selectedProducts.length,
			data: selectedProducts.map((obj) => ({
				product: obj.key_product,
				quantity: obj.quantity,
			})),
		};

		setStateUpload(true);
		const response_fetch = await CallApi({
			url: `api/company/product/transfer/insert?key_branch=${key_branch}`,
			method: 'post',
			body: array_data,
			showMessage: true
		});

		if (response_fetch?.code == 200) {
			refresh(key_branch);
			onClose();
		} 
		
		setStateUpload(false);
	}

	if (!isOpen) return null;

	return (
		<div className="modal-overlay-send-products">
			<div className="modal-content-send-products">
				{/* Botón de cerrar el modal */}
				<button className="close-modal-btn" onClick={onClose}>
					✖
				</button>

				{/* Encabezado con Checkbox y buscador */}
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						gap: "20px",
						justifyContent: "center",
						alignItems: "center",
						marginBottom: "10px",
					}}>
					{/* Checkbox "Listar todos" */}
					{/* <div style={{ margin: "10px 0" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={listAll}
                  onChange={(e) => setListAll(e.target.checked)}
                  color="primary"
                />
              }
              label="Listar todos"
            />
          </div> */}

					{/* Barra de búsqueda (deshabilitada si "Listar todos") */}
					<div className="search-send-product">
						<LupaIcon width={'30px'} height={'30px'} color="var(--theme-company)" />

						<input
							type="search"
							id="buscador"
							placeholder="Buscar Producto..."
							disabled={listAll}
							value={searchValue}
							onChange={handleInputChange}
						/>
						{/* Desplegable con productos filtrados (si no está "Listar todos", o incluso si está pero quieres mostrarlos igual) */}
						{searchValue.length > 0 && filteredOptions.length > 0 && !listAll && (
							<div className="dropdown-list">
								{filteredOptions.map((item) => (
									<div
										key={item?.code}
										className="dropdown-item"
										onClick={() => handleSelectProduct(item)}
									>
										<p><strong>{item?.code} </strong> - {item?.name}</p>
										<span className="result-stock "><strong>Stock:</strong> {item.stock} </span>
									</div>
								))}
							</div>
						)}
					</div>
				</div>

				{/* Si se selecciona "Listar todos", mostramos todos los productos aquí mismo: */}
				{listAll && (
					<div className="list-all-container">
						{filteredOptions.length > 0 ? (
							<div className="search-results-product">
								{filteredOptions.map((item) => (
									<div
										key={item.code}
										className="result-item"
										onClick={() => handleSelectProduct(item)}>
										<span className="result-code">{item.code}</span>
										<span className="result-name">{item.name}</span>
									</div>
								))}
							</div>
						) : (
							<div className="no-results">No se encontraron resultados.</div>
						)}
					</div>
				)}

				{/* Tabla de productos seleccionados */}
				<div className="table-container-send">
					<table className="products-table">
						<thead>
							<tr>
								<th>CÓDIGO</th>
								<th>NOMBRE</th>
								<th>PRECIO</th>
								<th>CANTIDAD</th>
							</tr>
						</thead>
						<tbody>
							{selectedProducts.map((product, index) => (
								<tr key={product.code}>
									<td>{product.code}</td>
									<td>{product.name}</td>
									<td>{product.price}</td>
									<td>
										<div className="quantity-actions">
											<div style={{ display: 'flex', gap: '10px', flexFlow: 'row nowrap' }}>
												<button
													className="quantity-btn minus"
													onClick={() => handleDecreaseQuantity(index)}>
													<FontAwesomeIcon icon={faMinus} />
												</button>
												<span className="quantity-value">{product.quantity}</span>
												<button
													className="quantity-btn plus"
													onClick={() => handleIncreaseQuantity(index)}>
													<FontAwesomeIcon icon={faPlus} />
												</button>
											</div>
											<button
												className="delete-btn-send"
												onClick={() => handleRemoveProduct(index)}>
												<FontAwesomeIcon icon={faTrash} />
											</button>
										</div>
									</td>
								</tr>
							))}
							{/* Si no hay productos seleccionados */}
							{selectedProducts.length === 0 && (
								<tr>
									<td colSpan="4" style={{ textAlign: "center" }}>
										No hay productos seleccionados.
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				{/* Sección de enviar */}
				<div className="modal-footer-send">
					<div style={{ visibility: "hidden" }}>
						<p>.</p>
					</div>
					<div className="select-merca">
						<span>Enviar mercadería a: </span>
						<select className="store-select" id="transfer-product">
							{sucursales &&
								sucursales.map((obj, index) => {
									return <option value={obj.key_branch}>{obj.fullName}</option>;
								})}
						</select>
					</div>
					<button className="send-button" disabled={stateUpload} onClick={sendProduct}>
						<span>Enviar</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default SendProducts;
